// extracted by mini-css-extract-plugin
module.exports = {"animated-title":"TitleAnimation_animated-title__1_MfI","animated-title__word":"TitleAnimation_animated-title__word__22IRR"};